import { useMemo } from "react";
import {
  getDiscriminatorQuery,
  UseBaseODataManagerHookProps,
  useBaseODataManager,
} from "@ucl/library";
import { IBoltComment } from "../types/IBoltComment";
import { DataManager, Query } from "@syncfusion/ej2-data";
import { IDiscriminator } from "@ucl/library";

export interface CommentsODataHookProps
  extends IDiscriminator,
    UseBaseODataManagerHookProps<IBoltComment> {}

export interface CommentsODataHookModule {
  commentsDataManager: DataManager | null;
  commentsQuery: Query;
}

export const useCommentsOData = (
  props: CommentsODataHookProps
): CommentsODataHookModule => {
  const { dataManager: commentsDataManager } = useBaseODataManager({
    ...props,
    removeLeadingQuestionMark: true,
    removeUnsupportedParameters: true,
  });

  const commentsQuery = useMemo(() => {
    const qry = getDiscriminatorQuery(props);
    qry.sortBy("createdAt", "asc");
    return qry;
  }, [props]);

  return { commentsDataManager, commentsQuery };
};
